import { connect } from 'react-redux'
import moment from 'moment'
import { reduxForm } from 'redux-form'
import { history } from '../../../store'
import { obj } from '../../../modules/utils'

import Component from './Note'
import { getItem, addItem, removeItem, replaceItem, setItemState } from '../../../modules/notes'
import { getClientList, clearClientList } from '../../../modules/clients'

const form = {
  form: 'note-form',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  validate: (values, props) => {
    const errors = {}
    if (!props.dirty) {
      return errors
    }
    if (!values.noteTitle) {
      errors.noteTitle = 'Note is empty'
    }
    return errors
  },
  onSubmit: (values, dispatch, props) => {
    const { noteId } = props
    if (noteId === 'new') {
      return props.addItem({
        ...values,
        clientId: values.clientId || null,
        date: values.date.format(),
      }).then(() => history.push('/schedule'))
    }
    return props.replaceItem(noteId, {
      ...values,
      clientId: values.clientId || null,
      date: values.date.format(),
    }).then(() => history.push('/schedule'))
  },
}

const mapActionCreators = {
  getItem,
  removeItem,
  setItemState,
  addItem,
  replaceItem,
  getClientList,
  clearClientList,
}

const mapStateToProps = (state, ownProps) => ({
  noteId: obj.deepGet(ownProps, ['match', 'params', 'note_id']),
  note: state.notes.get('item'),
  clientList: state.clients.get('clientList'),
  initialValues: {
    date: moment(state.notes.getIn(['item', 'date'])),
    noteTitle: state.notes.getIn(['item', 'noteTitle']),
    description: state.notes.getIn(['item', 'description']),
    noteType: state.notes.getIn(['item', 'noteType']),
    clientFullName: state.notes.getIn(['item', 'clientFullName']),
    clientId: state.notes.getIn(['item', 'clientId']),
  },
})

export default connect(mapStateToProps, mapActionCreators)(reduxForm(form)(Component))



// WEBPACK FOOTER //
// ./src/containers/schedule/note/index.js